import { post, get } from '../utils/request';
import { LoginResponse, UserInfo } from '../types';

// 安全加固：登录路径使用复杂随机后缀，防止暴力探测
// 如需更换路径，需同步修改后端 LOGIN_SECRET_SUFFIX 环境变量并重新部署
const LOGIN_SECRET_SUFFIX = 'k7X9mP2v';
const LOGIN_PATH = `/auth/login-${LOGIN_SECRET_SUFFIX}`;

// 登录
export async function login(account: string, password: string, ticket?: string, randstr?: string): Promise<LoginResponse> {
  return post<LoginResponse>(LOGIN_PATH, { account, password, ticket, randstr });
}

// 修改密码
export async function changePassword(oldPassword: string, newPassword: string): Promise<void> {
  return post('/auth/change-password', { oldPassword, newPassword });
}

// 获取当前用户信息
export async function getCurrentUser(): Promise<UserInfo> {
  return get<UserInfo>('/auth/me');
}

// 退出登录
export function logout(): void {
  localStorage.removeItem('token');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('campusInfo');
  window.location.href = '/login';
}
